module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAYAAACMo1E1AAABFklEQVRYhe3Yv0rDUBiG8SfHc8BdEig4hK4d6jUUHLwEKR2kzr2CjN6GOJTiDcSpN9BV0LU49K/gekQaGgdxcXD48oUGep4LePlxknAgkc/jK+AeaNGc1sAw8nm8olmw39aGZsIAWubQgv8KOGkBJy3gpAWctOPA2TTjtPeqNQco4oq3O0q/xaaZ1qTuY/2a9XCdkdqe+jtXLKa47kRlSx23e+5zcnaBSQaVt2r5Wov5I659U3mnFpxtX7ObP1TeUcfZNKP0W/bv48pb6jjXGamcGijjXHfC/uNF5dQArMoKYJIB9vySz6dEa5LI53GptqbccVz8dRRw0gJOWsBJCzhpASfN8PNzuIltDHALbA4t+dMSGH4DO4E3wEERlqUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y21.png
// module id = YBwk
// module chunks = 1